export const aciPromotions = {
    iconName: 'promotions',
    svgDef: {
        attr: { fill: 'none', viewBox: '0 0 24 25' },
        path: [
            {
                attr: {
                    d: 'M8.47 18.776c-.282.282-.847.282-1.27 0l-5.506-5.364c-.141-.142-.282-.283-.282-.565 0-.141.14-.424.282-.565l10.87-10.588c.142-.141.424-.282.565-.282h5.506c.423 0 .847.423.847.847v5.364c0 .142-.141.424-.282.565a.682.682 0 000 .988.682.682 0 00.988 0c.423-.423.706-.988.706-1.553V2.26A2.23 2.23 0 0018.634 0H13.13c-.564 0-1.13.282-1.553.706L.706 11.153C.282 11.576 0 12.14 0 12.706c0 .564.282 1.129.706 1.553l5.506 5.364c.423.424.988.706 1.553.706.564 0 1.129-.282 1.552-.706a.682.682 0 000-.988c-.14-.141-.564-.141-.847.141z',
                    fill: 'currentColor',
                },
            },
            {
                attr: {
                    d: 'M15.247 4.518c0 .564.423 1.129 1.129 1.129s1.13-.424 1.13-1.13c0-.705-.424-1.129-1.13-1.129s-1.13.424-1.13 1.13zM18.352 17.082l-2.117-.847a.776.776 0 01-.424-.706c0-.282.282-.565.706-.565h2.118c.423 0 .705-.282.705-.706 0-.423-.282-.705-.705-.705h-.847c0-.424-.283-.706-.706-.706-.424 0-.706.282-.706.706v.14c-.988 0-1.694.707-1.835 1.695-.142.988.282 1.976 1.27 2.259l2.118.847a.776.776 0 01.423.706c0 .282-.282.564-.706.564H15.53c-.424 0-.706.283-.706.706 0 .424.282.706.706.706h.847c0 .423.282.706.706.706.423 0 .706-.283.706-.706v-.141c.988-.141 1.694-.706 1.835-1.694.282-.989-.283-1.977-1.27-2.26z',
                    fill: 'currentColor',
                },
            },
            {
                attr: {
                    d: 'M17.082 10.588c-3.812 0-6.917 2.965-6.917 6.776 0 3.812 3.105 6.777 6.917 6.777S24 21.176 24 17.364c0-3.812-3.106-6.776-6.918-6.776zm0 12c-2.965 0-5.506-2.4-5.506-5.365 0-2.965 2.4-5.364 5.506-5.364 3.106 0 5.506 2.4 5.506 5.364 0 2.965-2.4 5.365-5.506 5.365z',
                    fill: 'currentColor',
                },
            },
        ],
    },
};
